export default __webpack_public_path__ + "static/media/slide-6.a429c157.webp";